export const REMOVE_ALL_DUPLICATES_TOOLTIP_ID = 'remove-all-duplicates-tooltip';

export const REMOVE_ALL_DUPLICATES_TOOLTIP_DURATION = 6000;

export const BEST_PHOTO_TOOLTIP_ID = 'best-photo-tooltip';

export const BEST_PHOTO_VIEWER_TOOLTIP_ID = 'best-photo-viewer-tooltip';

export const DUPLICATES_PAGE_BASE_URL = '/albums/duplicates';

export const DUPLICATES_SUCCESS_CLEAR_ACTION__NAME = 'success-clear';

export const DUPLICATES_PAY_SOURCE = 'mail_web_duplicates_modal';
